import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

const AppRedirectPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0F1114] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <img src={logo} alt="CricClash" className="w-20 h-20 rounded-2xl mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-white mb-3">CricClash</h1>
        <p className="text-gray-400 mb-8">
          The app is coming soon to App Store and Google Play. In the meantime, enjoy the full experience on the web.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#13EC5B] text-black rounded-xl font-semibold text-sm hover:bg-[#10D450] transition-all"
        >
          Go to Web App
        </Link>
      </div>
    </div>
  );
};

export default AppRedirectPage;
